import { connect } from 'react-redux'
import TranscriptionPanel from './TranscriptionPanel'
import { getTranscription, getCachedTranscription } from './transcription.actions'
import { getCachedEntry } from './transcription.cache'

export const mapStateToProps = ({
  media: {
    transcription,
    main: { storageFile },
  },
}) => ({
  ...transcription,
  transcriptionLoading: transcription.loading,
  loading: transcription.loading || storageFile.loading,
})

const mapDispatchToProps = dispatch => ({
  async requestTranscription(contactId, isRootRecording, cache) {
    const cachedEntry = getCachedEntry(cache, contactId)
    if (cachedEntry) {
      dispatch(getCachedTranscription(contactId))
    } else {
      await dispatch(getTranscription(contactId, isRootRecording))
    }
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(TranscriptionPanel)
